import { useEffect } from 'react';

import { User } from '@ergeon/erg-auth';

import { setSentryUser } from '../utils/sentry';

const useSentryUser = (user: User | undefined) => {
  useEffect(() => {
    setSentryUser(user);
  }, [user]);
};

export default useSentryUser;
